import { Injectable, ErrorHandler } from '@angular/core'
import * as Sentry from '@sentry/browser'
import { environment } from '../../../../environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  constructor() { }

  handleError(error) {
    const email = localStorage.getItem('persona');

    if (email) {
        Sentry.setUser({ email });
    }

    if (environment.envName === 'staging' || environment.envName === 'prod') {
      Sentry.captureException(error.originalError || error)
    } else {
      console.log(error)
    }
  }
}
